import { useCallback, useEffect, useState } from 'react';
import { ISelectCustomProps } from '../interfaces';

const useMenuHandlers = (selectProps: ISelectCustomProps) => {
  const {
    onOpen,
    onClose,
    isClosePortalMenuOnScroll = false,
    isUsePortal,
    scrollableParentElements,
  } = selectProps;

  const [menuIsOpen, setMenuIsOpen] = useState<boolean>(false);

  const onMenuOpen = () => {
    setMenuIsOpen(true);

    if (typeof onOpen === 'function') {
      onOpen();
    }
  };

  const onMenuClose = () => {
    setMenuIsOpen(false);

    if (typeof onClose === 'function') {
      onClose();
    }
  };

  const scrollHandler = useCallback(() => {
    if (isClosePortalMenuOnScroll) {
      onMenuClose();
    }
  }, []);

  useEffect(() => {
    if (isUsePortal && scrollableParentElements) {
      scrollableParentElements.forEach((element) => {
        element?.addEventListener('scroll', scrollHandler);
      });
    }

    return () => {
      if (isUsePortal && scrollableParentElements) {
        scrollableParentElements.forEach((element) => {
          element?.removeEventListener('scroll', scrollHandler);
        });
      }
    };
  }, [scrollableParentElements, isClosePortalMenuOnScroll]);

  return {
    menuIsOpen,
    onMenuOpen,
    onMenuClose,
  };
};

export default useMenuHandlers;
